var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:{ 'icon-thumbnail': _vm.icon },attrs:{"src":_vm.imgData,"alt":"thumbnail"}})
}
var staticRenderFns = []

export { render, staticRenderFns }